module.exports = __webpack_public_path__ + "img/sniper_nest_small.2298730c.png";